<template>
	<div>
		<h2>Jak to funguje</h2>
		<div class="how-it-works">
			<template v-for="(item, index) in howItWorksItems">
				<how-it-works-item :item="item" :key="index"></how-it-works-item>
			</template>
		</div>
		<slot name="rules_block">
			<div class="rules_block">
				<div :class="['center mbtn', btnCssClass]">
					<a :href="[eventRulesUrl]">Pravidla akce</a>
				</div>
			</div>
		</slot>
	</div>
</template>

<script>
import HowItWorksItem from './HowItWorksItem';

export default {
	name: 'BaseHowItWorks',
	components: { HowItWorksItem },
	props: {
		eventRulesUrl: {
			type: String,
			default: '#'
		},
		howItWorksItems: {
			type: Array,
			required: true
		},
		btnCssClass: {
			type: String,
			default: ''
		}
	}
}
</script>

<style scoped></style>
